var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DesignPreview',{staticClass:"line-item-preview",attrs:{"preview-urls":_vm.line.preview_urls,"rounded":_vm.roundedCorners,"edit-button":"true"},on:{"edit":function($event){return _vm.$emit('edit')}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fd08377","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/LineItemPreview.vue
// module id = UGVJ
// module chunks = 1